export default __webpack_public_path__ + "static/media/logo05.e583f97d.svg";